import {
  TB_MOVIE,
  TB_REVIEW,
  TB_REVIEW_REFERENCE,
  TB_REVIEW_SCENE,
} from "../config";
import { supabase } from "./supabase";

const fetchReviewData = async (reviewId) => {
  const { data, error } = await supabase
    .from(TB_REVIEW)
    .select(
      `
      rid,
      title,
      description,
      rating,
      is_mini_review,
      mid,
      ${TB_MOVIE} (
        mid,
        poster
      )
    `
    )
    .eq("rid", reviewId)
    .single();
  if (error) {
    console.error("Error fetching movie data:", error.message);
    throw error;
  }

  return {
    title: data.title,
    description: data.description,
    rating: data.rating,
    poster: data.movie?.poster,
    mid: data.mid,
    isMini: data.is_mini_review,
  };
};

const fetchReviewShots = async (reviewId) => {
  const { data, error } = await supabase
    .from(TB_REVIEW_SCENE)
    .select("url")
    .eq("rid", reviewId);

  if (error) {
    console.error("Error fetching review shot data:", error.message);
    throw error;
  }

  const urls = data.map((el) => el.url);
  return urls;
};

const getAllReviews = async () => {
  try {
    const { data: reviews, error: reviewError } = await supabase
      .from(TB_REVIEW)
      .select(`rid, rating, title, mid`)
      .order("rid", { ascending: false });

    if (reviewError) throw reviewError;
    if (!reviews || reviews.length === 0) return [];

    const { data: movies, error: movieError } = await supabase
      .from(TB_MOVIE)
      .select("mid, poster");

    if (movieError) throw movieError;

    const flatReviews = reviews.map((r) => ({
      ...r,
      poster: movies.find((m) => m.mid === r.mid)?.poster || null,
    }));

    return flatReviews;
  } catch (error) {
    console.error("Error fetching all reviews:", error);
    throw error;
  }
};

const fetchReviewRefs = async (reviewId) => {
  const { data, error } = await supabase
    .from(TB_REVIEW_REFERENCE)
    .select(`url, poster, title`)
    .eq("id", reviewId);

  if (error) {
    console.error("Error fetching movie ref data:", error.message);
    throw error;
  }

  return data;
};

const getReviewData = async (reviewId) => {
  try {
    const reviewData = await fetchReviewData(reviewId);

    const reviewGallery = await fetchReviewShots(reviewId);

    const reviewRefs = await fetchReviewRefs(reviewId);

    return {
      reviewData,
      reviewGallery,
      reviewRefs,
    };
  } catch (error) {
    console.error("Error in get review data:", error);
  }
};

export { getReviewData, getAllReviews };
